// TODO: delete this folder when cleaning up bulk_operations_floating_toolbar

import { type MutableRefObject, useEffect, useMemo, useLayoutEffect } from 'react';
import throttle from 'lodash/throttle';
import { getTokenValue } from '@atlaskit/tokens';
import { useBulkActionsBar } from '../bulk-actions-bar-controller/index.tsx';
import { BULK_ACTIONS_BAR_HEIGHT } from '../constants.tsx';

const OFFSET = (parseInt(getTokenValue('space.150', '12px'), 10) || 12) + BULK_ACTIONS_BAR_HEIGHT;

export const useBulkActionsBarOverlay = (ref: MutableRefObject<HTMLDivElement | null>) => {
	const [{ isOpen }, { setIsOverlaid, setShouldCloseGracefully }] = useBulkActionsBar();

	const handleScroll: () => void = useMemo(
		() =>
			throttle(() => {
				if (ref.current) {
					const currentScrollPosition = ref.current.scrollTop;
					const isOverlaid = currentScrollPosition > 0;
					const shouldCloseGracefully = currentScrollPosition < OFFSET;

					setIsOverlaid(isOverlaid);
					setShouldCloseGracefully(shouldCloseGracefully);
				}
			}, 100),
		[ref, setIsOverlaid, setShouldCloseGracefully],
	);

	useEffect(() => {
		const currentRef = ref.current;
		if (currentRef) {
			if (isOpen) {
				currentRef.addEventListener('scroll', handleScroll);
			} else {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		}
		return () => {
			if (currentRef) {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		};
	}, [handleScroll, isOpen, ref, setIsOverlaid, setShouldCloseGracefully]);

	useLayoutEffect(() => {
		const currentRef = ref.current;

		if (currentRef) {
			const currentScrollPosition = currentRef.scrollTop;

			if (currentScrollPosition === 0) {
				if (isOpen) {
					currentRef.scrollTop = currentScrollPosition + OFFSET;
					setIsOverlaid(true);
				} else {
					currentRef.scrollTop = currentScrollPosition - OFFSET;
				}
			}
		}
	}, [isOpen, ref, setIsOverlaid]);
};
